import React, { useEffect, useState } from 'react';
import { Virtuoso } from 'react-virtuoso';
import { Close } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import * as actions from '~/store/actions';
import { RootState } from '~/store/config';
import * as Loaders from '~/components/Loaders';
import { SmsTemplate } from '~/types/accountInfo';
import { CircularLoader } from '~/components/CallHistory/styles';
import { Body, Button, Container, Header, Loader, RowItem } from './styles';

type TemplatesProps = {
  onClose: () => void;
  /**
   * Emitted when the user clicks a template
   * @param template returns the selected template
   */
  onTemplateChange: (template: SmsTemplate) => void;
};

export default function Templates({
  onClose,
  onTemplateChange,
}: TemplatesProps) {
  // HOOK's
  const dispatch = useDispatch();
  const { t } = useTranslation();

  // STATE's
  const [page, setPage] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(false);

  // SELECTOR's
  const { smsTemplates } = useSelector((state: RootState) => state.accountInfo);

  // CONST's
  const perPage = 45;

  const Row = ({ item: template }: { item: SmsTemplate }) => {
    const { id, name, usage, messageText } = template;

    return (
      <RowItem
        key={id}
        usage={usage}
        onClick={() => onTemplateChange(template)}>
        <span>{name}</span>
        <span>{messageText}</span>
      </RowItem>
    );
  };

  const handleEndReached = () => {
    const newPage = page + 1;
    dispatch(actions.fetchSmsTemplates(newPage, perPage));
    setPage(newPage);
  };

  const handleStartReached = () => {
    const newPage = 1;
    dispatch(actions.fetchSmsTemplates(newPage, perPage));
    setPage(newPage);
  };

  // EFFECT's
  useEffect(() => {
    dispatch(actions.fetchSmsTemplates(page, perPage));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    if (smsTemplates.length === 0) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [smsTemplates]);

  return (
    <Container>
      <Header>
        <span>{t('screens.conversation.selectTemplate')}</span>
        <Button onClick={onClose}>
          <Close color="inherit" />
        </Button>
      </Header>
      <Body>
        {loading ? (
          <Loader>
            <Loaders.List numRows={10} />
          </Loader>
        ) : (
          <Virtuoso
            item={index => <Row item={smsTemplates[index]} />}
            totalCount={smsTemplates.length}
            style={{ flex: 1 }}
            startReached={handleStartReached}
            endReached={handleEndReached}
            footer={() => (
              <>{loading && <CircularLoader size={30} thickness={2} />}</>
            )}
          />
        )}
      </Body>
    </Container>
  );
}
